import { isPhone } from '@helpers';

export const ATTACH_ITEM_STYLES = {
  borderRadius: 36,
  paddingHorizontal: 15,
  height: isPhone ? 30 : 46,
};

export const ATTACH_ITEMS_LIST_STYLES = {
  marginBottom: 20,
}
export const ICON_TEXT_GAP = 10;

export const INFO_POPUP_OPTION_KEY: Record<string, string> = {
  'Download Now': 'download',
  'Get Info': 'info',
  Delete: 'delete',
};